export const SEARCH_PROMOTED_EVENT_CARD_URGENCY_SIGNALS = {
    name: 'search_promoted_event_card_urgency_signals',
    param: 'with_urgency_signals',
};
